import * as React from "react"
import { Link } from "../../custom_components/components/library/link"
import { LinkButton } from "../../custom_components/components/library/button"
import { Row } from "../../custom_components/components/library/container"
import { trackNewsletter, trackMembership } from "../../custom_components/components/library/tracking"

const footerTop = () => <div className="footer__top">
<div className="footer__container container--mg align--center">
  <Row>
    <div className="col-xs-12 col-md-4">
      <div className="footer__column">
        <div className="footer__inner">
          <h2 className="footer__title title--s">Altijd op de hoogte</h2>
          <p className="footer__text">
            Mis niks van de laatste ontwikkelingen uit jouw bibliotheek! Schrijf je in voor
            de nieuwsbrief en ontvang leestips, het laatste nieuws en de leukste activiteiten.
          </p>
          <LinkButton className="footer__button" route="https://fbn.hostedwise.nl/wise-apps/opac/8090/subscription/newsletter" handle={() => trackNewsletter()}>
            <span className="button__label">Aanmelden nieuwsbrief</span>
          </LinkButton>
        </div>
      </div>
    </div>
    <div className="col-xs-12 col-md-4">
      <div className="footer__column">
        <div className="footer__inner">
          <h2 className="footer__title title--s">Als lid kun je meer</h2>
          <p className="footer__text">
            Kies uit een groot aantal boeken, e-books, luisterboeken, cursussen, activiteiten
            en meer. Als lid kun je volop lezen, leren en lenen.
          </p>
          <LinkButton className="footer__button" route="/lid-worden" handle={() => trackMembership()}>
            <span className="button__label">Word lid</span>
          </LinkButton>
        </div>
      </div>
    </div>
    <div className="col-xs-12 col-md-4">
      <div className="footer__column footer__social">
        <div className="footer__inner">
          <h2 className="footer__title title--s">Volg ons</h2>
          <p className="footer__text">
            Via onze social media kanalen volg je wat er allemaal gebeurt in de bieb.
          </p>
          <div className="footer__socials">
            <Link className="button button--primary button--icon" url="https://www.facebook.com/flevomeerbibliotheek" title="Facebook">
              <span className="sr-text">Facebook</span>
              <svg className="button__icon social__icon" width="24" height="24" aria-hidden="true">
                <use xlinkHref="#icon--facebook" />
              </svg>
            </Link>
            <Link className="button button--primary button--icon" url="https://www.linkedin.com/company/flevomeer-bibliotheek" title="LinkedIn">
              <span className="sr-text">LinkedIn</span>
              <svg className="button__icon social__icon" width="24" height="24" aria-hidden="true">
                <use xlinkHref="#icon--linkedin" />
              </svg>
            </Link>
            <Link className="button button--primary button--icon" url="https://twitter.com/flevomeerbieb" title="Twitter">
              <span className="sr-text" id="social-twitter">Twitter</span>
              <svg className="button__icon social__icon" width="24" height="24" aria-hidden="true">
                <use xlinkHref="#icon--twitter" />
              </svg>
            </Link>
            <Link className="button button--primary button--icon" url="https://www.instagram.com/flevomeerbieb" title="Instagram">
              <span className="sr-text">Instagram</span>
              <svg className="button__icon social__icon" width="24" height="24" aria-hidden="true">
                <use xlinkHref="#icon--instagram" />
              </svg>
            </Link>
            <Link className="button button--primary button--icon" url="https://www.youtube.com/channel/UC9wKJTX1qWWost3Zo2vb8rA" title="YouTube">
              <span className="sr-text">YouTube</span>
              <svg className="button__icon social__icon" width="24" height="24" aria-hidden="true">
                <use xlinkHref="#icon--youtube" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  </Row>
</div>

<img className="footer__logo" src="/bkw/images/flevo/logo-aanzet.svg" alt="" width="100" height="100" aria-hidden="true" loading="lazy" />
</div>

export default footerTop